/*
 * @Date: 2022-08-24 10:17:36
 * @LastEditTime: 2022-08-29 17:46:17
 * @Description: file content
 * @FilePath: \traffic\src\apis\common\common.js
 */
import api from '../api-request';

const getScrmVersion = () => {
  // version 1专业版 3旗舰版
  const reallyOid = window?.current_org?.oid || window?.AppConf?.org?.oid || window.top?.current_org?.oid
  return api.get('/traffic/config/version/get', {
    // oid redux里有 每个需要这个接口的page都要引入 userInfo 每个需要的且没有使用redux的地方都要包redux 不方便 直接取window下的
    params: {
      oid: process.env.NODE_ENV === 'development' ? process.env?.OID : reallyOid
    }
  })
};

const checkApply = () => {
  const reallyOid = window?.current_org?.oid || window?.AppConf?.org?.oid || window.top?.current_org?.oid
  return api.get('/traffic/wx/config/version/check', {
    params: {
      oid: process.env.NODE_ENV === 'development' ? process.env?.OID : reallyOid
    }
  })
}
//当前企业是否处在SCRM和CRM融合灰测中
const blendedCheck = () => {
  const reallyOid = window?.current_org?.oid || window?.AppConf?.org?.oid || window.top?.current_org?.oid
  return api.get('/traffic/wx/config/blended/check', {
    params: {
      oid: process.env.NODE_ENV === 'development' ? process.env?.OID : reallyOid
      // oid:10005775
    }
  })
}

export default {
  getScrmVersion,
  checkApply,
  blendedCheck
}
